import api from "@/services/api";
import cookies from "js-cookie";

export default {
  async getCSRFCookie() {
    try {
      const res = await api.get(`/sanctum/csrf-cookie`);
      return res.data;
    } catch (error) {
      return null;
    }
  },

  register(data) {
    return api.post(`/api/v1/register`, data);
  },

  login(data) {
    return api.post(`/api/v1/login`, data);
  },

  logout() {
    cookies.remove("kyano_access_token");
    cookies.remove("kyano_user");
    location.replace("/login");
    return api.post(`/api/v1/logout`);
  },

  passwordReset(data) {
    return api.post(`/api/v1/password/reset`, data);
  },
  passwordSet(data) {
    return api.post(`/api/v1/password/set`, data);
  }
};
